/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DocumentVO } from '../model';
// @ts-ignore
import { FileInfoVO } from '../model';
// @ts-ignore
import { TempFileDobaPlatnosti } from '../model';
// @ts-ignore
import { TypDokumentuVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * DocumentControllerApi - axios parameter creator
 * @export
 */
export const DocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {File} dokumentSoubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocument: async (idData: number, dokumentSoubor: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('addDocument', 'idData', idData)
            // verify required parameter 'dokumentSoubor' is not null or undefined
            assertParamExists('addDocument', 'dokumentSoubor', dokumentSoubor)
            const localVarPath = `/api/document/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (idData !== undefined) {
                localVarQueryParameter['idData'] = idData;
            }


            if (dokumentSoubor !== undefined) { 
                localVarFormParams.append('dokumentSoubor', dokumentSoubor as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {string} [kodOrganizace] Kód organizace.
         * @param {string} [kodTypDokument] Kód typu dokumentu. Není-li předán, uloží se dokument jako obrázek (příloha uživatelské vrstvy).
         * @param {string} [popis] Popis dokumentu.
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentInBody: async (idData: number, kodOrganizace?: string, kodTypDokument?: string, popis?: string, body?: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('addDocumentInBody', 'idData', idData)
            const localVarPath = `/api/document/{idData}/add`
                .replace(`{${"idData"}}`, encodeURIComponent(String(idData)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kodOrganizace !== undefined) {
                localVarQueryParameter['kodOrganizace'] = kodOrganizace;
            }

            if (kodTypDokument !== undefined) {
                localVarQueryParameter['kodTypDokument'] = kodTypDokument;
            }

            if (popis !== undefined) {
                localVarQueryParameter['popis'] = popis;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Založí dočasný soubor.
         * @param {TempFileDobaPlatnosti} dobaPlatnosti Doba platnosti souboru.
         * @param {File} soubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemporaryFile: async (dobaPlatnosti: TempFileDobaPlatnosti, soubor: File, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dobaPlatnosti' is not null or undefined
            assertParamExists('createTemporaryFile', 'dobaPlatnosti', dobaPlatnosti)
            // verify required parameter 'soubor' is not null or undefined
            assertParamExists('createTemporaryFile', 'soubor', soubor)
            const localVarPath = `/api/document/temporary-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (dobaPlatnosti !== undefined) {
                localVarQueryParameter['dobaPlatnosti'] = dobaPlatnosti;
            }


            if (soubor !== undefined) { 
                localVarFormParams.append('soubor', soubor as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže dokument daných dat.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID mazaného dokumentu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (idData: number, idDokument: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('deleteDocument', 'idData', idData)
            // verify required parameter 'idDokument' is not null or undefined
            assertParamExists('deleteDocument', 'idDokument', idDokument)
            const localVarPath = `/api/document/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idData !== undefined) {
                localVarQueryParameter['idData'] = idData;
            }

            if (idDokument !== undefined) {
                localVarQueryParameter['idDokument'] = idDokument;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí ID všech dokumentů daných dat.
         * @param {number} idData ID dat, pro které chceme najít všechny dokumenty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDocumentsByData: async (idData: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('findDocumentsByData', 'idData', idData)
            const localVarPath = `/api/document/find-docs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idData !== undefined) {
                localVarQueryParameter['idData'] = idData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findImagesByData: async (idData: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('findImagesByData', 'idData', idData)
            const localVarPath = `/api/document/find-images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idData !== undefined) {
                localVarQueryParameter['idData'] = idData;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí soubor daného dokumentu. Pokud je předána maximální šířka nebo výška, vrátí pouze náhled tohoto souboru.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID dokumentu.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (idData: number, idDokument: number, maxWidth?: number, maxHeight?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idData' is not null or undefined
            assertParamExists('getDocument', 'idData', idData)
            // verify required parameter 'idDokument' is not null or undefined
            assertParamExists('getDocument', 'idDokument', idDokument)
            const localVarPath = `/api/document/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idData !== undefined) {
                localVarQueryParameter['idData'] = idData;
            }

            if (idDokument !== undefined) {
                localVarQueryParameter['idDokument'] = idDokument;
            }

            if (maxWidth !== undefined) {
                localVarQueryParameter['maxWidth'] = maxWidth;
            }

            if (maxHeight !== undefined) {
                localVarQueryParameter['maxHeight'] = maxHeight;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} idTempFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFile: async (idTempFile: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idTempFile' is not null or undefined
            assertParamExists('getTemporaryFile', 'idTempFile', idTempFile)
            const localVarPath = `/api/document/temporary-file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idTempFile !== undefined) {
                localVarQueryParameter['idTempFile'] = idTempFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí info o dočasném souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFileInfo: async (idTempFile: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idTempFile' is not null or undefined
            assertParamExists('getTemporaryFileInfo', 'idTempFile', idTempFile)
            const localVarPath = `/api/document/temporary-file/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idTempFile !== undefined) {
                localVarQueryParameter['idTempFile'] = idTempFile;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí náhled dočasného souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFilePreview: async (idTempFile: string, maxWidth?: number, maxHeight?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idTempFile' is not null or undefined
            assertParamExists('getTemporaryFilePreview', 'idTempFile', idTempFile)
            const localVarPath = `/api/document/temporary-file/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idTempFile !== undefined) {
                localVarQueryParameter['idTempFile'] = idTempFile;
            }

            if (maxWidth !== undefined) {
                localVarQueryParameter['maxWidth'] = maxWidth;
            }

            if (maxHeight !== undefined) {
                localVarQueryParameter['maxHeight'] = maxHeight;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypyDokumentu: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/document/typy-dokumentu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentControllerApi - functional programming interface
 * @export
 */
export const DocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {File} dokumentSoubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDocument(idData: number, dokumentSoubor: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.addDocument(idData, dokumentSoubor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {string} [kodOrganizace] Kód organizace.
         * @param {string} [kodTypDokument] Kód typu dokumentu. Není-li předán, uloží se dokument jako obrázek (příloha uživatelské vrstvy).
         * @param {string} [popis] Popis dokumentu.
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDocumentInBody(idData: number, kodOrganizace?: string, kodTypDokument?: string, popis?: string, body?: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.addDocumentInBody(idData, kodOrganizace, kodTypDokument, popis, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Založí dočasný soubor.
         * @param {TempFileDobaPlatnosti} dobaPlatnosti Doba platnosti souboru.
         * @param {File} soubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemporaryFile(dobaPlatnosti: TempFileDobaPlatnosti, soubor: File, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemporaryFile(dobaPlatnosti, soubor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Smaže dokument daných dat.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID mazaného dokumentu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(idData: number, idDokument: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(idData, idDokument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí ID všech dokumentů daných dat.
         * @param {number} idData ID dat, pro které chceme najít všechny dokumenty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDocumentsByData(idData: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findDocumentsByData(idData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findImagesByData(idData: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.findImagesByData(idData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí soubor daného dokumentu. Pokud je předána maximální šířka nebo výška, vrátí pouze náhled tohoto souboru.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID dokumentu.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(idData: number, idDokument: number, maxWidth?: number, maxHeight?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(idData, idDokument, maxWidth, maxHeight, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} idTempFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemporaryFile(idTempFile: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemporaryFile(idTempFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí info o dočasném souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemporaryFileInfo(idTempFile: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileInfoVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemporaryFileInfo(idTempFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Vrátí náhled dočasného souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemporaryFilePreview(idTempFile: string, maxWidth?: number, maxHeight?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemporaryFilePreview(idTempFile, maxWidth, maxHeight, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypyDokumentu(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TypDokumentuVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypyDokumentu(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentControllerApi - factory interface
 * @export
 */
export const DocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentControllerApiFp(configuration)
    return {
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {File} dokumentSoubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocument(idData: number, dokumentSoubor: File, options?: any): AxiosPromise<void> {
            return localVarFp.addDocument(idData, dokumentSoubor, options).then((request) => request(axios, basePath));
        },
        /**
         * Uloží dokument k daným datům.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {string} [kodOrganizace] Kód organizace.
         * @param {string} [kodTypDokument] Kód typu dokumentu. Není-li předán, uloží se dokument jako obrázek (příloha uživatelské vrstvy).
         * @param {string} [popis] Popis dokumentu.
         * @param {File} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDocumentInBody(idData: number, kodOrganizace?: string, kodTypDokument?: string, popis?: string, body?: File, options?: any): AxiosPromise<void> {
            return localVarFp.addDocumentInBody(idData, kodOrganizace, kodTypDokument, popis, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Založí dočasný soubor.
         * @param {TempFileDobaPlatnosti} dobaPlatnosti Doba platnosti souboru.
         * @param {File} soubor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemporaryFile(dobaPlatnosti: TempFileDobaPlatnosti, soubor: File, options?: any): AxiosPromise<string> {
            return localVarFp.createTemporaryFile(dobaPlatnosti, soubor, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže dokument daných dat.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID mazaného dokumentu.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(idData: number, idDokument: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocument(idData, idDokument, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí ID všech dokumentů daných dat.
         * @param {number} idData ID dat, pro které chceme najít všechny dokumenty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDocumentsByData(idData: number, options?: any): AxiosPromise<Array<DocumentVO>> {
            return localVarFp.findDocumentsByData(idData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findImagesByData(idData: number, options?: any): AxiosPromise<Array<number>> {
            return localVarFp.findImagesByData(idData, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí soubor daného dokumentu. Pokud je předána maximální šířka nebo výška, vrátí pouze náhled tohoto souboru.
         * @param {number} idData ID dat, ke kterým se dokument váže.
         * @param {number} idDokument ID dokumentu.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(idData: number, idDokument: number, maxWidth?: number, maxHeight?: number, options?: any): AxiosPromise<File> {
            return localVarFp.getDocument(idData, idDokument, maxWidth, maxHeight, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} idTempFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFile(idTempFile: string, options?: any): AxiosPromise<File> {
            return localVarFp.getTemporaryFile(idTempFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí info o dočasném souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFileInfo(idTempFile: string, options?: any): AxiosPromise<FileInfoVO> {
            return localVarFp.getTemporaryFileInfo(idTempFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí náhled dočasného souboru.
         * @param {string} idTempFile ID dočasného souboru.
         * @param {number} [maxWidth] Maximální šířka obrázku.
         * @param {number} [maxHeight] Maximální výška obrázku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemporaryFilePreview(idTempFile: string, maxWidth?: number, maxHeight?: number, options?: any): AxiosPromise<File> {
            return localVarFp.getTemporaryFilePreview(idTempFile, maxWidth, maxHeight, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypyDokumentu(options?: any): AxiosPromise<Array<TypDokumentuVO>> {
            return localVarFp.getTypyDokumentu(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentControllerApi - interface
 * @export
 * @interface DocumentControllerApi
 */
export interface DocumentControllerApiInterface {
    /**
     * Uloží dokument k daným datům.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {File} dokumentSoubor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    addDocument(idData: number, dokumentSoubor: File, options?: any): AxiosPromise<void>;

    /**
     * Uloží dokument k daným datům.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {string} [kodOrganizace] Kód organizace.
     * @param {string} [kodTypDokument] Kód typu dokumentu. Není-li předán, uloží se dokument jako obrázek (příloha uživatelské vrstvy).
     * @param {string} [popis] Popis dokumentu.
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    addDocumentInBody(idData: number, kodOrganizace?: string, kodTypDokument?: string, popis?: string, body?: File, options?: any): AxiosPromise<void>;

    /**
     * Založí dočasný soubor.
     * @param {TempFileDobaPlatnosti} dobaPlatnosti Doba platnosti souboru.
     * @param {File} soubor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    createTemporaryFile(dobaPlatnosti: TempFileDobaPlatnosti, soubor: File, options?: any): AxiosPromise<string>;

    /**
     * Smaže dokument daných dat.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {number} idDokument ID mazaného dokumentu.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    deleteDocument(idData: number, idDokument: number, options?: any): AxiosPromise<void>;

    /**
     * Vrátí ID všech dokumentů daných dat.
     * @param {number} idData ID dat, pro které chceme najít všechny dokumenty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    findDocumentsByData(idData: number, options?: any): AxiosPromise<Array<DocumentVO>>;

    /**
     * 
     * @param {number} idData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    findImagesByData(idData: number, options?: any): AxiosPromise<Array<number>>;

    /**
     * Vrátí soubor daného dokumentu. Pokud je předána maximální šířka nebo výška, vrátí pouze náhled tohoto souboru.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {number} idDokument ID dokumentu.
     * @param {number} [maxWidth] Maximální šířka obrázku.
     * @param {number} [maxHeight] Maximální výška obrázku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    getDocument(idData: number, idDokument: number, maxWidth?: number, maxHeight?: number, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {string} idTempFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    getTemporaryFile(idTempFile: string, options?: any): AxiosPromise<File>;

    /**
     * Vrátí info o dočasném souboru.
     * @param {string} idTempFile ID dočasného souboru.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    getTemporaryFileInfo(idTempFile: string, options?: any): AxiosPromise<FileInfoVO>;

    /**
     * Vrátí náhled dočasného souboru.
     * @param {string} idTempFile ID dočasného souboru.
     * @param {number} [maxWidth] Maximální šířka obrázku.
     * @param {number} [maxHeight] Maximální výška obrázku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    getTemporaryFilePreview(idTempFile: string, maxWidth?: number, maxHeight?: number, options?: any): AxiosPromise<File>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApiInterface
     */
    getTypyDokumentu(options?: any): AxiosPromise<Array<TypDokumentuVO>>;

}

/**
 * DocumentControllerApi - object-oriented interface
 * @export
 * @class DocumentControllerApi
 * @extends {BaseAPI}
 */
export class DocumentControllerApi extends BaseAPI implements DocumentControllerApiInterface {
    /**
     * Uloží dokument k daným datům.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {File} dokumentSoubor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public addDocument(idData: number, dokumentSoubor: File, options?: any) {
        return DocumentControllerApiFp(this.configuration).addDocument(idData, dokumentSoubor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uloží dokument k daným datům.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {string} [kodOrganizace] Kód organizace.
     * @param {string} [kodTypDokument] Kód typu dokumentu. Není-li předán, uloží se dokument jako obrázek (příloha uživatelské vrstvy).
     * @param {string} [popis] Popis dokumentu.
     * @param {File} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public addDocumentInBody(idData: number, kodOrganizace?: string, kodTypDokument?: string, popis?: string, body?: File, options?: any) {
        return DocumentControllerApiFp(this.configuration).addDocumentInBody(idData, kodOrganizace, kodTypDokument, popis, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Založí dočasný soubor.
     * @param {TempFileDobaPlatnosti} dobaPlatnosti Doba platnosti souboru.
     * @param {File} soubor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public createTemporaryFile(dobaPlatnosti: TempFileDobaPlatnosti, soubor: File, options?: any) {
        return DocumentControllerApiFp(this.configuration).createTemporaryFile(dobaPlatnosti, soubor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže dokument daných dat.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {number} idDokument ID mazaného dokumentu.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public deleteDocument(idData: number, idDokument: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).deleteDocument(idData, idDokument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí ID všech dokumentů daných dat.
     * @param {number} idData ID dat, pro které chceme najít všechny dokumenty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public findDocumentsByData(idData: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).findDocumentsByData(idData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public findImagesByData(idData: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).findImagesByData(idData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí soubor daného dokumentu. Pokud je předána maximální šířka nebo výška, vrátí pouze náhled tohoto souboru.
     * @param {number} idData ID dat, ke kterým se dokument váže.
     * @param {number} idDokument ID dokumentu.
     * @param {number} [maxWidth] Maximální šířka obrázku.
     * @param {number} [maxHeight] Maximální výška obrázku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public getDocument(idData: number, idDokument: number, maxWidth?: number, maxHeight?: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).getDocument(idData, idDokument, maxWidth, maxHeight, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} idTempFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public getTemporaryFile(idTempFile: string, options?: any) {
        return DocumentControllerApiFp(this.configuration).getTemporaryFile(idTempFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí info o dočasném souboru.
     * @param {string} idTempFile ID dočasného souboru.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public getTemporaryFileInfo(idTempFile: string, options?: any) {
        return DocumentControllerApiFp(this.configuration).getTemporaryFileInfo(idTempFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí náhled dočasného souboru.
     * @param {string} idTempFile ID dočasného souboru.
     * @param {number} [maxWidth] Maximální šířka obrázku.
     * @param {number} [maxHeight] Maximální výška obrázku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public getTemporaryFilePreview(idTempFile: string, maxWidth?: number, maxHeight?: number, options?: any) {
        return DocumentControllerApiFp(this.configuration).getTemporaryFilePreview(idTempFile, maxWidth, maxHeight, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentControllerApi
     */
    public getTypyDokumentu(options?: any) {
        return DocumentControllerApiFp(this.configuration).getTypyDokumentu(options).then((request) => request(this.axios, this.basePath));
    }
}
